var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNightShift = function SvgNightShift(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.847656,
    width: 16,
    height: 16,
    rx: 8,
    fill: "url(#paint0_linear_7189_69999)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7189_69999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 13
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.84766,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7189_69999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.05467 13.0399C6.87007 13.0399 5.86558 12.6277 5.04122 11.8033C4.21687 10.979 3.80469 9.97449 3.80469 8.78988C3.80469 7.80336 4.10997 6.92645 4.72054 6.15915C5.3311 5.39184 6.1444 4.89728 7.16041 4.67548C7.36234 4.62484 7.51923 4.6742 7.63109 4.82356C7.74295 4.97292 7.7524 5.13702 7.65945 5.31586C7.55625 5.50368 7.47965 5.69919 7.42965 5.9024C7.37965 6.1056 7.35465 6.31809 7.35465 6.53988C7.35465 7.3604 7.64119 8.0572 8.21427 8.63028C8.78736 9.20336 9.48416 9.4899 10.3047 9.4899C10.5502 9.4899 10.7848 9.45881 11.0085 9.39663C11.2322 9.33446 11.4281 9.26235 11.596 9.1803C11.755 9.10851 11.9021 9.11988 12.0373 9.21443C12.1726 9.30898 12.2213 9.45273 12.1835 9.64568C12.0059 10.629 11.5276 11.4405 10.7484 12.0803C9.96924 12.72 9.07133 13.0399 8.05467 13.0399Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7189_69999",
    x1: 8,
    y1: 0.847656,
    x2: 8,
    y2: 16.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#687EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3733FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNightShift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "night-shift.21b434a6153cdd0104581b6b832b5936.svg";